"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "Labelstyle__StyledLabel",
  componentId: "sc-bphac3-0"
})(["", ";"], function (props) {
  var isDisabled = props.isDisabled;
  var _props$theme = props.theme,
    spacing = _props$theme.spacing,
    color = _props$theme.palette;
  return (0, _styledComponents.css)(["font-size:", ";text-transform:capitalize;font-weight:400;", ""], spacing.small, isDisabled && (0, _styledComponents.css)(["color:", ";"], color.gray.bravo));
});
StyledLabel.displayName = 'StyledLabel';
var _default = exports["default"] = StyledLabel;